export default "__VITE_ASSET__iGzi6D4C__"